import _capitalize from 'lodash/capitalize';
//
import React from 'react';

import type { LoadingButtonProps } from '@mui/lab/LoadingButton';
import LoadingButton from '@mui/lab/LoadingButton';

export type QButtonProps = LoadingButtonProps & {
  onClick?: (e?: any) => void;
};

/**
 * QButton should be used instead of the MUI Button. QButton is a thin wrapper whose primary purpose
 * is to add a handler for the "Enter" key which will call the onClick() action.
 */
const QButtonNew = React.forwardRef<any, QButtonProps>((props, ref) => {
  // eslint-disable-next-line react/prop-types
  const { children, onClick, ...other } = props;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (onClick && (e.keyCode === 13 || e.key === 'Enter')) {
      onClick(e);
    }
  };

  const transformedChildren = React.Children.map(children, (child: any) => {
    if (typeof child === 'string') {
      return _capitalize(child); // Transform text children
    }
    return child; // Return other components as-is
  });

  return (
    <LoadingButton onClick={onClick} onKeyDown={handleKeyDown} ref={ref} {...other}>
      {transformedChildren}
    </LoadingButton>
  );
});

QButtonNew.displayName = 'QButtonNew';

export default QButtonNew;
